import { useOktaAuth } from '@okta/okta-react';
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Heading, Text, VStack, Center, Alert } from '@chakra-ui/react';
import PulseLoader from "react-spinners/PulseLoader";
import VerificationInput from "react-verification-input";
import { useTranslation } from 'react-i18next';

const UserIdentityVerification = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { t } = useTranslation();

  const { authState, oktaAuth } = useOktaAuth();
  const [userInfo, setUserInfo] = useState(null);
  const [validationData, setValidationData] = useState(location.state?.validationData);
  const [loading, setLoading] = useState(false);
  const [apiResponse, setApiResponse] = useState(null);
  const [showCodeEntry, setShowCodeEntry] = useState(true);
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (!authState || !authState.isAuthenticated) {
      // When user isn't authenticated, forget any user info
      setUserInfo(null);
      setValidationData(null);
    } else {
      oktaAuth.getUser().then((info) => {
        setUserInfo(info);
      });
      console.log(validationData);
    }
  }, [authState, oktaAuth]); // Update if authState changes

  const handleChange = (newValue) => {
    setLoading(true);

    fetch(validationData.next, {
      method: 'POST',
      body: JSON.stringify({
        sessionid: validationData.session_id,
        challenge_value: newValue,
      }),
      headers: {
        Authorization: 'Bearer ' + authState.accessToken.accessToken
      }
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.statusCode && data.statusCode !== 200) {
          navigate('/Error', {
            state: {
              errorMessage: data.message,
              errorDetails: t("Please restart your browser and try Identity Validation again.")
            }
          });
        } else {
          console.log(data);
          setApiResponse(data);
          setLoading(false);
          if (data.result === "INCORRECT") {
            setShowCodeEntry(true);
            setShowError(true);
          } else {
            setShowCodeEntry(false);
            setShowSuccess(true);
            setShowError(false);
          }
        }
      }).catch(error => {
        navigate('/Error', {
          state: { 
            errorMessage: error.message,
            errorDetails: t("Please restart your browser and try Identity Validation again.")
          }
        });
      });
  };

  if (!authState) {
    oktaAuth.signInWithRedirect({ originalUri: '/' });
    return (
      <div>Loading...</div>
    );
  }

  return (
    <Box id="home">
      {loading &&
        <Box className="sweet-loading">
          <Box className="centered">
            <PulseLoader
              loading={loading}
              color="#dadada"
              size={30}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </Box>
        </Box>
      }
      <Box>
        { authState.isAuthenticated && !userInfo
        && <Box>{t('Loading user information')}...</Box>}

        {authState.isAuthenticated && userInfo
        && (
          <Center>
            <VStack spacing={6} width="100%">
              <Heading as="h1" size="2xl">{t('Secondary Verification Required')}</Heading>
              <Box p={8} borderWidth="1px" borderRadius="lg" bg="white" shadow="sm" width="100%">
                { showCodeEntry && 
                  <Text mb={4}>
                    {t('secondary_auth_message')}
                  </Text>
                }
                { showError && 
                  <Alert.Root status="error" mb={4}>
                    <Alert.Indicator />
                    <Alert.Content>
                      <Alert.Title>{t("The code you entered is incorrect. Please try again.")}</Alert.Title>
                    </Alert.Content>
                  </Alert.Root>
                }
                { showSuccess && 
                  <Alert.Root status="success" mb={4}>
                    <Alert.Indicator />
                    <Alert.Content>
                      <Alert.Title>{t("Identity Verification Successful")}</Alert.Title>
                    </Alert.Content>
                  </Alert.Root>
                }
                { showCodeEntry &&
                  <Box className="code_input" display="flex" justifyContent="center" style={{ paddingTop: '20px' }}>
                    <VerificationInput
                      autoFocus={true}
                      placeholder=' '
                      validChars='0-9'
                      onComplete={handleChange}
                      length={4}
                    />
                  </Box>
                }
              </Box>
            </VStack>
          </Center>
        )}
      </Box>
    </Box>
  );
};
export default UserIdentityVerification;
